// mysynch-modal-container.component.ts
import { Component, ViewChild, ViewContainerRef, Inject, AfterViewInit  } from '@angular/core';
import { ModalService } from '../services/modal.service';


@Component({
  standalone: false,
  selector: 'mysynch-modal-container',
  template: '<div #mysynchModalContainer><ng-content></ng-content></div>',
})
export class MysynchModalContainerComponent implements AfterViewInit  {
  @ViewChild('mysynchModalContainer', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  private mysynchModalContainerRef: any;
  

  constructor(@Inject(ModalService) private modalService:ModalService ) {
  }
  
  ngAfterViewInit() {
    this.mysynchModalContainerRef = this.viewContainerRef;
    this.modalService.addModalContainerRef('mysynch-modal-container',this.mysynchModalContainerRef);
  }
}
